import MainPage from './app/pages/MainPage';
import Services from './app/pages/Services';
import WorkWithUs from './app/pages/WorkWithUs';
import About from './app/pages/About';
import Jobs from './app/pages/Jobs';
import JobPage from './app/pages/Jobs/page';
import BlogList from './app/pages/Blog/list';
import RAAS from './app/pages/RAAS';
import Page1 from './app/pages/Blog/1';
import Page2 from './app/pages/Blog/2';
import Staffing from './app/pages/Staffing';
import { createBrowserRouter } from 'react-router-dom';

const routes = createBrowserRouter([
  {
    path: '/',
    element: <MainPage />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/work-with-us',
    element: <WorkWithUs />,
  },
  {
    path: '/raas',
    element: <RAAS />,
  },
  {
    path: '/staffing_solutions',
    element: <Staffing />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/jobs/:id',
    element: <JobPage />,
  },
  {
    path: '/jobs',
    element: <Jobs />,
  },
  {
    path: '/blog/10-ways-humans-are-better-than-an-ai-interviewer/',
    element: <Page1 />,
  },
  {
    path: '/blog/AI-can-find-matches/',
    element: <Page2 />,
  },
  {
    path: '/blog',
    element: <BlogList />,
  },
]);

export default routes;
